import {
  GET_WORKFLOW_ACTIONS_PENDING,
  GET_WORKFLOW_ACTIONS_FULFILLED,
  GET_WORKFLOW_ACTIONS_REJECTED,
  GET_WORKFLOW_NEXT_STATE_PENDING,
  GET_WORKFLOW_NEXT_STATE_FULFILLED,
  GET_WORKFLOW_NEXT_STATE_REJECTED,
  RESET_ACTIONS,
} from "../actions/types";

const initialState = {
  data: [],
  nextState: {},
  loading: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_WORKFLOW_ACTIONS_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_WORKFLOW_ACTIONS_FULFILLED:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
      };
    case GET_WORKFLOW_ACTIONS_REJECTED:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };

    case GET_WORKFLOW_NEXT_STATE_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_WORKFLOW_NEXT_STATE_FULFILLED:
      return {
        ...state,
        nextState: action.payload,
        loading: false,
        error: false,
      };
    case GET_WORKFLOW_NEXT_STATE_REJECTED:
      return {
        ...state,
        nextState: {},
        loading: false,
        error: true,
      };
    case RESET_ACTIONS:
      return {
        ...state,
        data: [],
        nextState: {},
      };
    default:
      return state;
  }
}
